import { FC, ReactNode } from 'react';

export type NbaFeedbackWrapperComponentProps = {
  children: ReactNode;
  nbaFeedback?: string;
};

// NBA feedback has no Belgium Digital Core endpoint, so this wrapper only renders its children.
export const NbaFeedbackWrapperComponent: FC<NbaFeedbackWrapperComponentProps> = ({ children }) => <>{children}</>;
